import { types } from "../types/types";

export const setNotifications = (data) => {
    return {
      type: types.setNotifications,
      payload: data,
    };
  };